<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title--Front-Matter-">Supernatural Noir</p>
<p class="ORIM-Author-Name--Front-Matter-">edited by Ellen Datlow</p>
<p class="centersb">
<span class="center"> <img alt="images" src="image/logo.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?7313034a